import { render } from "./MarriageCertificate.vue?vue&type=template&id=5b9a365a"
import script from "./MarriageCertificate.vue?vue&type=script&lang=js"
export * from "./MarriageCertificate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__